
export default {
  name: 'Checklist',

  props: {
    heading: String,
    items: Array
  }
}
